import {
    API_DATA_BERKAS_ELEKTRONIK
} from 'shared/constants/ActionTypes';

const INIT_STATE = {
    list: {
        results: []
    }
};

const uploadBerkasReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_DATA_BERKAS_ELEKTRONIK: {
            return {
                ...state,
                list: action.payload
            }
        }
        default:
            return state;
    }
};
export default uploadBerkasReducer;
